const initialState = {
  isRTL: false
}

export const home = {
  namespaced: true,
  state: initialState,
  actions: {
    setIsRTL ({ commit }, isRTL) {
      commit('setIsRTL', isRTL)
    }
  },
  mutations: {
    setIsRTL (state, isRTL) {
      console.log(isRTL)
      state.isRTL = isRTL
    }
  },
  getters: {
    isRTL: (state) => {
      return state.isRTL
    }
  }
}
